import React from 'react'
import './AtributosMedicos.css'
import atributo1 from '../assets/icons/especialidad-1-a.png'
import atributo2 from '../assets/icons/especialidad-2.png'
import atributo3 from '../assets/icons/especialidad-3-a.png'
import atributo4 from '../assets/icons/especialidad-4-a.png'
import atributo5 from '../assets/icons/especialidad-5-a.png'

const especialidades = [
  {
    id: 1,
    img: atributo1,
    titulo: 'Endocrinología clínica general',
    descripcion:
      'Evaluación integral de las glándulas endocrinas y sus hormonas, abarcando diagnóstico y tratamiento de trastornos hormonales y metabólicos en adultos.',
  },
  {
    id: 2,
    img: atributo2,
    titulo: 'Diabetes Mellitus y metabolismo',
    descripcion:
      'Atención especializada en el manejo de la diabetes tipo 1 y tipo 2, con enfoque en control metabólico, prevención de complicaciones y educación al paciente.',
  },
  {
    id: 3,
    img: atributo3,
    titulo: 'Trastornos tiroideos',
    descripcion:
      'Diagnóstico y seguimiento de enfermedades como hipotiroidismo, hipertiroidismo y cáncer de tiroides, utilizando criterios clínicos y evidencia científica.',
  },
  {
    id: 4,
    img: atributo4,
    titulo: 'Obesidad y síndrome metabólico',
    descripcion:
      'Abordaje médico y nutricional de la obesidad y sus causas hormonales, con énfasis en mejorar la salud cardiovascular y el equilibrio metabólico.',
  },
  {
    id: 5,
    img: atributo5,
    titulo: 'Salud hormonal femenina y menopausia',
    descripcion:
      'Evaluación de desequilibrios hormonales femeninos, manejo de la menopausia y apoyo en salud reproductiva y bienestar general de la mujer.',
  },
]

const AtributosMedicos = () => {
  return (
    <section className="atributos-container" id="especialidades">
      <h2>Áreas de Especialidad Médica</h2>

      <div className="especialidades-grid">
        {especialidades.map(({ id, img, titulo, descripcion }) => (
          <article key={id} className="especialidad-item">
            <div className="especialidad-img">
              <img src={img} alt={titulo} loading="lazy" />
            </div>
            <div className="especialidad-info">
              <h3>{titulo}</h3>
              <p>{descripcion}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default AtributosMedicos
